import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import router from './router'
import { store } from './store/index'
// import './registerServiceWorker'
import VueResource from 'vue-resource'
import VueNativeSock from 'vue-native-websocket'
import Notifications from 'vue-notification'
import VueApexCharts from 'vue-apexcharts'

import './styles/common.scss'
// KAN-95 暗室暗色主題：token 與覆寫層必須在 common.scss「之後」import，
// source order 讓 .theme-dark 覆寫勝出（配合特異度）
import './styles/theme-tokens.scss'
import './styles/theme-dark.scss'
import './styles/components/tables.scss'
import { applyThemeClass } from './utils/theme'
import './plugins/date-range-picker'
import './filters/date-filter'
import common from './utils/common'
import { i18n } from './locale'

Vue.use(VueResource)
Vue.use(VueApexCharts)

Vue.use(Notifications)

Vue.use(VueNativeSock, 'ws://localhost:8052', {
  format: 'S16LE',
  connectManually: true,
})

Vue.config.productionTip = false

Vue.http.options.xhr = {
  withCredentials: true,
}
Vue.http.options.emulateJSON = true

Vue.component('apexchart', VueApexCharts)

Vue.config.errorHandler = function () {
  void 0
}

/**
 * 啟動流程：先 fetch 醫院別 runtime config，再 mount Vue
 * 這確保 i18n locale 和 feature flags 在第一次 render 就正確
 * 若 fetch 失敗，使用預設值（backward compat：等同 HOSPITAL=default）
 */
async function bootstrap() {
  // KAN-95 暗室暗色主題：mount 前先把 root class 套上（state.ui.theme 已於 store 初始化解析），
  // 避免第一次 render 亮底閃一下才轉暗
  applyThemeClass(store.state.ui.theme)

  // Step 1: 載入醫院別 runtime 配置
  try {
    const resp = await fetch('/api/config/runtime')
    if (resp.ok) {
      const hospitalConfig = await resp.json()
      store.dispatch('setHospital', hospitalConfig)

      // 用醫院配置的預設語系覆寫 i18n（runtime 驅動，取代 locale/index.js 寫死的值）
      if (hospitalConfig.locale && hospitalConfig.locale.default) {
        const targetLocale = hospitalConfig.locale.default
        if (i18n.availableLocales.includes(targetLocale)) {
          i18n.locale = targetLocale
        }
      }
      void 0
    } else {
      void 0
    }
  } catch (_) {
    // fetch 失敗（server 尚未啟動 / 網路問題）→ 使用預設值，不阻擋 mount
    void 0
  }

  // Step 2: mount Vue
  await store.dispatch('refreshLicenseRuntime')

  const vm = new Vue({
    i18n,
    router,
    store,
    render: (h) => h(App),
    created() {
      store
        .dispatch('ensureSetting')
        .then(setting => {
          this.$connect(common.getASRUrl(
            setting.asr_domain,
            setting.asr_ws_port,
            setting.asr_ws_path,
          ))
        })
        .catch(() => {
          void 0
        })
    },
    methods: {
      set_locale(locale) {
        if (
          this.$i18n &&
          this.$i18n.availableLocales &&
          this.$i18n.availableLocales.includes(locale)
        ) {
          this.$i18n.locale = locale
        }
      }
    },
  }).$mount('#app')
}

bootstrap()
